import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function setBannerCategoria() {
  const banner = document.querySelector('[data-banner-categorias]');

  if (banner) {
    const carousel = banner.querySelector('.swiper');
    const next = banner.querySelector('.swiper-button-next');
    const prev = banner.querySelector('.swiper-button-prev');

    new Swiper(carousel, {
      modules: [Navigation],
      slidesPerView: 2,
      spaceBetween: 32,
      watchOverflow: true,
      speed: 1000,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        991: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 5,
        },
      },
    });
  }
}
